import type { ComboboxItem, DataGridFilterRenderContext } from '@ibsys/kit';
import { Combobox } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useExpertReports } from '@/entities/expert-report';
import { ListTruncationNotice } from '@/shared/ui';

/** Потолок выдачи метода списка заключений; за ним отбор показывает, что список неполон */
const REPORTS_LIMIT = 100;

type Props = {
  ctx: DataGridFilterRenderContext;
};

/** Фильтр колонки «Заключение»: одиночный выбор из списка экспертных заключений. */
export const ExpertReportFilter: FC<Props> = ({ ctx }) => {
  const { t } = useTranslation(['common']);
  const { data, isFetching } = useExpertReports({ limit: REPORTS_LIMIT });

  const options = useMemo<ComboboxItem[]>(
    () => (data?.items ?? []).map((report) => ({ value: report.id, label: report.name })),
    [data?.items],
  );

  return (
    <div className="flex flex-col gap-2 p-2 min-w-56">
      <Combobox
        options={options}
        value={(ctx.value as number | undefined) ?? undefined}
        onChange={(value) => ctx.setValue((value as number | undefined) ?? undefined)}
        isLoading={isFetching}
        placeholder={t('common:select')}
        className="w-full"
      />
      <ListTruncationNotice shown={options.length} total={data?.total} className="text-xs" />
    </div>
  );
};
